import React from "react";
import { observer } from "mobx-react";
import appStore from "../../assets/home/appstore.png";
import ggPlay from "../../assets/home/googleplay.png";
import popUpStore, { EPopUp } from "../../stores/popup.store";

interface IFooterProps {}

export const Footer: React.FC<IFooterProps> = observer(() => {
  return (
    <footer className="flex flex-col bg-[#002A41] pt-8 mt-0 pb-8 px-8 md:px-60 flex-wrap gap-4 md:gap-3 justify-start items-center">
      <div className="flex flex-wrap justify-center items-center gap-3 md:gap-5">
        <a
          href="https://www.youtube.com/@travelokavn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.53083 0C4.26699 0 0 4.25319 0 9.5C0 14.7468 4.26699 19 9.53083 19C14.7947 19 19.0617 14.7468 19.0617 9.5C19.0617 4.25319 14.7947 0 9.53083 0ZM15.6193 12.5484C15.4724 13.0931 15.0432 13.5224 14.4953 13.6687C13.5041 13.9333 9.53083 13.9333 9.53083 13.9333C9.53083 13.9333 5.55753 13.9333 4.56632 13.6687C4.01989 13.5224 3.58924 13.0945 3.44239 12.5484C3.17694 11.5604 3.17694 9.5 3.17694 9.5C3.17694 9.5 3.17694 7.43956 3.44239 6.45156C3.58924 5.90689 4.01848 5.47763 4.56632 5.33126C5.55753 5.06667 9.53083 5.06667 9.53083 5.06667C9.53083 5.06667 13.5041 5.06667 14.4953 5.33126C15.0418 5.47763 15.4724 5.90548 15.6193 6.45156C15.8847 7.43956 15.8847 9.5 15.8847 9.5C15.8847 9.5 15.8847 11.5604 15.6193 12.5484Z"
              fill="white"
            />
            <path
              d="M8.26005 11.4001L11.5612 9.5001L8.26005 7.6001V11.4001Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://www.facebook.com/TravelokaVN/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.84361 0C4.57977 0 0.312782 4.25319 0.312782 9.5C0.312782 14.2416 3.79753 18.1724 8.35397 18.8846V12.2459H5.93385V9.5H8.35397V7.40719C8.35397 5.02585 9.77724 3.71133 11.9545 3.71133C12.998 3.71133 14.088 3.89711 14.088 3.89711V6.23481H12.8864C11.7018 6.23481 11.3332 6.96667 11.3332 7.71822V9.5H13.9765L13.5543 12.2459H11.3332V18.8846C15.8897 18.1724 19.3744 14.2416 19.3744 9.5C19.3744 4.25319 15.1074 0 9.84361 0Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://www.tiktok.com/@traveloka.vn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.1564 0C4.89255 0 0.625565 4.25319 0.625565 9.5C0.625565 14.7468 4.89255 19 10.1564 19C15.4202 19 19.6872 14.7468 19.6872 9.5C19.6872 4.25319 15.4202 0 10.1564 0ZM15.3948 8.41207C15.039 8.41207 14.6902 8.36422 14.3443 8.28541C13.7499 8.1503 13.202 7.90963 12.6923 7.57607C12.6655 7.55919 12.6372 7.52118 12.609 7.53385C12.5737 7.55074 12.592 7.59578 12.592 7.62956C12.592 8.99193 12.5977 10.3543 12.5892 11.7181C12.5836 12.6709 12.28 13.5224 11.6545 14.2486C10.9895 15.0199 10.1451 15.4674 9.13271 15.5913C8.35189 15.687 7.6106 15.5462 6.90744 15.1986C6.79307 15.1423 6.68435 15.0776 6.58268 15.0016C6.55021 14.9734 6.51915 14.9453 6.48667 14.9171C6.41042 14.8847 6.34829 14.8284 6.28476 14.7792C5.65643 14.2824 5.21448 13.6575 4.97021 12.8947C4.88549 12.6301 4.83325 12.357 4.80642 12.0798C4.78806 11.8785 4.78524 11.6773 4.79795 11.4774C4.8276 11.0158 4.93773 10.5724 5.12976 10.1502C5.33026 9.7083 5.60277 9.31704 5.9487 8.97785C6.35253 8.58378 6.82131 8.28822 7.35362 8.09681C7.68826 7.97718 8.03137 7.904 8.38719 7.87867C8.64417 7.86037 8.89973 7.866 9.1553 7.89556C9.18919 7.89978 9.21037 7.90681 9.20896 7.94763C9.20613 8.08837 9.20613 8.23052 9.20472 8.37126C9.20754 8.37407 9.2259 9.44652 9.2259 9.9377C9.2259 9.95459 9.2259 9.97289 9.2259 9.98978C9.22308 10.039 9.19766 10.0559 9.15106 10.0419C9.01693 10.0039 8.87714 9.98556 8.73877 9.97852C8.52273 9.96726 8.30953 9.99822 8.10761 10.0714C7.42987 10.3205 7.01898 10.8047 6.93285 11.5168C6.84813 12.2191 7.12629 12.7807 7.71226 13.1846C7.76168 13.2184 7.8111 13.2507 7.8577 13.2887C7.86899 13.2986 7.88029 13.3084 7.89017 13.3183C8.02713 13.3718 8.16268 13.4267 8.3067 13.4548C8.76701 13.5449 9.19907 13.4759 9.59866 13.231C10.059 12.9481 10.3315 12.533 10.4261 12.0038C10.4444 11.9039 10.4473 11.8011 10.4473 11.6998C10.4473 8.96378 10.4473 6.22778 10.4473 3.49178C10.4473 3.3637 10.4289 3.38059 10.5574 3.38059C11.19 3.38059 11.8239 3.38059 12.4565 3.38059C12.472 3.38059 12.4861 3.38059 12.5017 3.38059C12.5666 3.38059 12.568 3.38059 12.5666 3.44674C12.5666 3.59311 12.6273 3.93652 12.633 3.96326C12.9069 5.34674 14.5236 6.19259 15.0235 6.26718C15.1604 6.2883 15.2988 6.30519 15.4386 6.30378C15.4965 6.30378 15.4979 6.30518 15.4979 6.36007C15.4979 6.48815 15.5233 7.81111 15.5219 8.29526C15.5219 8.40644 15.5064 8.41207 15.3948 8.41207Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://instagram.com/traveloka.vn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            className="w-[24px] h-[24px] md:w-[36px] md:h-[36px]"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.147 5.97166C15.0383 5.69299 14.9084 5.49314 14.698 5.28344C14.4877 5.07373 14.2886 4.94425 14.0076 4.83588C13.7958 4.75425 13.4781 4.65714 12.8935 4.6304C12.261 4.60225 12.0704 4.59521 10.4692 4.59521C8.86799 4.59521 8.67738 4.60084 8.04482 4.6304C7.46026 4.65714 7.14256 4.75425 6.93077 4.83588C6.65119 4.94425 6.45069 5.07373 6.24031 5.28344C6.02992 5.49314 5.90002 5.69159 5.7913 5.97166C5.70941 6.18277 5.61198 6.49944 5.58515 7.0821C5.55691 7.71262 5.54985 7.90262 5.54985 9.49862C5.54985 11.0946 5.5555 11.2846 5.58515 11.9151C5.61198 12.4978 5.70941 12.8145 5.7913 13.0256C5.90002 13.3043 6.02992 13.5041 6.24031 13.7138C6.45069 13.9235 6.64978 14.053 6.93077 14.1614C7.14256 14.243 7.46026 14.3401 8.04482 14.3668C8.67738 14.395 8.86658 14.402 10.4692 14.402C12.0718 14.402 12.261 14.3964 12.8935 14.3668C13.4781 14.3401 13.7958 14.243 14.0076 14.1614C14.2871 14.053 14.4877 13.9235 14.698 13.7138C14.9084 13.5041 15.0383 13.3057 15.147 13.0256C15.2289 12.8145 15.3264 12.4978 15.3532 11.9151C15.3814 11.2846 15.3885 11.0946 15.3885 9.49862C15.3885 7.90262 15.3828 7.71262 15.3532 7.0821C15.3264 6.49944 15.2289 6.18277 15.147 5.97166ZM10.4692 12.571C8.76774 12.571 7.38824 11.196 7.38824 9.50003C7.38824 7.8041 8.76774 6.42907 10.4692 6.42907C12.1706 6.42907 13.5501 7.8041 13.5501 9.50003C13.5501 11.196 12.1706 12.571 10.4692 12.571ZM13.6729 7.0244C13.2748 7.0244 12.9528 6.70351 12.9528 6.30662C12.9528 5.90973 13.2748 5.58884 13.6729 5.58884C14.0711 5.58884 14.393 5.90973 14.393 6.30662C14.393 6.70351 14.0711 7.0244 13.6729 7.0244Z"
              fill="white"
            />
            <path
              d="M10.4692 0C5.20533 0 0.938347 4.25319 0.938347 9.5C0.938347 14.7468 5.20533 19 10.4692 19C15.733 19 20 14.7468 20 9.5C20 4.25319 15.733 0 10.4692 0ZM16.4348 11.9658C16.4051 12.6019 16.3049 13.0368 16.1552 13.4182C16.0013 13.8109 15.7965 14.1444 15.4633 14.478C15.1301 14.8101 14.7955 15.0156 14.4001 15.1676C14.0189 15.3154 13.5826 15.4167 12.943 15.4463C12.3033 15.4759 12.0986 15.4829 10.4692 15.4829C8.83975 15.4829 8.63502 15.4759 7.99539 15.4463C7.35718 15.4167 6.92088 15.3168 6.53823 15.1676C6.14429 15.0142 5.80966 14.8101 5.47502 14.478C5.14179 14.1459 4.93564 13.8123 4.78315 13.4182C4.63489 13.0382 4.53323 12.6033 4.50358 11.9658C4.47393 11.3282 4.46687 11.1241 4.46687 9.5C4.46687 7.87585 4.47393 7.67178 4.50358 7.03422C4.53323 6.39807 4.63348 5.96318 4.78315 5.58178C4.93705 5.18911 5.14179 4.85556 5.47502 4.522C5.80825 4.18985 6.14288 3.98437 6.53823 3.83237C6.91947 3.68459 7.35577 3.58326 7.99539 3.5537C8.63502 3.52415 8.83975 3.51711 10.4692 3.51711C12.0986 3.51711 12.3033 3.52415 12.943 3.5537C13.5812 3.58326 14.0175 3.68319 14.4001 3.83237C14.794 3.98578 15.1287 4.18985 15.4633 4.522C15.7965 4.85415 16.0027 5.1877 16.1552 5.58178C16.3035 5.96178 16.4051 6.39667 16.4348 7.03422C16.4644 7.67178 16.4715 7.87585 16.4715 9.5C16.4715 11.1241 16.4644 11.3282 16.4348 11.9658Z"
              fill="white"
            />
            <path
              d="M10.4692 7.50562C9.36502 7.50562 8.46841 8.39791 8.46841 9.49991C8.46841 10.6019 9.3636 11.4942 10.4692 11.4942C11.5748 11.4942 12.4699 10.6019 12.4699 9.49991C12.4699 8.39791 11.5748 7.50562 10.4692 7.50562Z"
              fill="white"
            />
          </svg>
        </a>
      </div>

      <p className="text-white text-center text-sm leading-[1.25rem] md:text-base">
        Tải ngay Siêu ứng dụng du lịch và tiện ích sống Traveloka cho hành trình
        sắp tới của bạn
      </p>

      <div className="w-6/12 md:w-[20%] flex flex-wrap justify-center items-center mt-3">
        <a
          href="https://apps.apple.com/vn/app/traveloka-hotel-flight/id898244857"
          rel="noreferrer"
          target="_blank"
        >
          <img src={appStore} alt="App Store TVLK" className="w-full" />
        </a>
      </div>

      <div className="w-6/12 md:w-[20%] flex flex-wrap justify-center items-center mt-3">
        <a
          href="https://play.google.com/store/apps/details?id=com.traveloka.android&hl=vi&gl=US&pli=1"
          rel="noreferrer"
          target="_blank"
        >
          <img src={ggPlay} alt="GG Play TVLK" className="w-full" />
        </a>
      </div>

      <div className="mt-3 flex flex-col gap-1">
        <p className="text-center text-white md:text-base">
          Copyright © 2024 Traveloka
        </p>
        <p className="text-center text-white md:text-base">
          Cần hỗ trợ về cuộc thi Nhả Chữ Nhận Quà
        </p>
        {/* <a href="mailto:minigamevn@traveloka.com?subject=Cu%E1%BB%99c%20Thi%20Nh%E1%BA%A3%20Ch%E1%BB%AF%20Nh%E1%BA%ADn%20Qu%C3%A0">
          <p className="text-center text-white font-bold underline cursor-pointer md:text-base">
            Liên hệ với Traveloka bạn nhé!
          </p>
        </a> */}

        <p
          onClick={() => popUpStore.openModal(EPopUp.CONTACT_FORM)}
          className="text-center text-white font-bold underline cursor-pointer md:text-base"
        >
          Liên hệ với Traveloka bạn nhé!
        </p>
      </div>
    </footer>
  );
});
